import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController,LoadingController, ModalController } from 'ionic-angular';
import { DbservicesProvider } from '../../providers/dbservices/dbservices';
import { PrintProvider } from '../../providers/print/print';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';
import * as qz from 'qz-tray';
// import { sha256 } from 'js-sha256';
 // import * as shajs from 'sha.js';
import {MarkaspaidPage} from '../../pages/markaspaid/markaspaid';


@Component({
  selector: 'page-orderdetails',
  templateUrl: 'orderdetails.html',
})
export class OrderdetailsPage {
  item: any;
  resturant;
  url;
  res;
  delivery_slot;
  constructor(public loadingCtrl: LoadingController,private btSerial:BluetoothSerial,public print:PrintProvider, public DBservice: DbservicesProvider,public alertCtrl: AlertController, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public modalCtrl: ModalController) {
    this.item = navParams.get('item');
    console.log(this.item);
    this.url = this.DBservice.baseUrl;
    this.get_restaurant()
        this.get_restaurant_preparation_time()


  }
  ionViewWillEnter() {
    // qz.websocket.connect().then(function() {
    //  alert("Connected!");
    // });
    // qz.api.setSha256Type(data => sha256(data));
    // qz.api.setPromiseType(resolver => new Promise(resolver));

    // qz.websocket.connect()
    //  .then(qz.printers.getDefault)
    //  .then(printer => console.log("The default printer is: " + printer))
    //  .then(qz.websocket.disconnect)
    //  .catch(err => console.error(err));
  }

  get_restaurant_preparation_time(){
    var orderdata = {
      business:localStorage.restaurant
    }
    this.DBservice.get_restaurant_preparation_time(orderdata)
      .then(data => {
        console.log(data);
        this.delivery_slot = data.message;
        
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }


  printStuff() {
   var config = qz.configs.create("Printer Name");

   var data = [
      'Raw Data\n',
      'More Raw Data\n',
      'Even More Raw Data\n'
   ];

   qz.print(config, data).catch(function(e) { console.error(e); });
  }

  testprint(){
    // this.print.testPrint(localStorage.bluetoothid,com)
    console.log('testprint')
    var ProductList = ''
    var address;
    // var item=componentName;
    var item=this.item;
      for (var i = 0; i < item.order_item.length; i++) {
        var product_name = '';
        // if(item.order_item[i].item_name.length > 18)
          // product_name = this.print.fillspace(18, item.order_item[i].item_name,'backspace').substring(0, 18)
        // else{
          var product = item.order_item[i].item_name;
          product = product.match(/.{1,18}/g)
          console.log(product)
          for(var j=0;j < product.length; j++){
                product_name = product_name + this.print.fillspace(18, product[j],'backspace').trimLeft() + this.print.nextline(product[j+1]);               

          }
          var attribute = '';
          if(item.order_item[i].attribute_description){
            var data = item.order_item[i].attribute_description.replace(/<br>/,'\n')
            var d= data.replace( /(<([^>]+)>)/ig, '')
            console.log(d)
            attribute=  d.trim();
          }
          // var count=0;
          // for(var j=18;j < item.order_item[i].item_name.length; j = j+18){
          //       count =0;
          //       product_name = product_name + this.print.fillspace(j, item.order_item[i].item_name,'backspace').substring(count, j) + this.print.nextline(item.order_item[i].item_name.substring(count, j));
          //       count = count + 18;
          //       j = j+
          // }
        // }
        var special_instruction_name = '';
        if(item.order_item[i].special_instruction){
        var special_instruction = item.order_item[i].special_instruction;
          special_instruction = 'Note: '+special_instruction;
          special_instruction = special_instruction.match(/.{1,32}/g)
          console.log(special_instruction)
          for(var j=0;j < special_instruction.length; j++){
                special_instruction_name = special_instruction_name + this.print.fillspace(32, special_instruction[j],'backspace').trimLeft() + this.print.nextline(special_instruction[j+1]);               

          }
        }
        // console.log(item.order_item[i].special_instruction)    
        ProductList = ProductList + product_name + this.print.fillspace(3, item.order_item[i].quantity +'x', 'frontspace')+ ""+this.print.fillspace(5, +item.order_item[i].price, 'frontspace')+ "" +  this.print.fillspace(6, +item.order_item[i].amount, 'frontspace') +"\n" +attribute +this.print.nextline(attribute) +special_instruction_name +this.print.nextline(special_instruction_name) 
        // ProductList = ProductList +this.print.fillspace(18, item.order_item[i].item_name,'backspace').substring(0, 18)+ this.print.fillspace(3, item.order_item[i].quantity +'x', 'frontspace')+ ""+this.print.fillspace(5, +item.order_item[i].price, 'frontspace')+ "" +  this.print.fillspace(6, +item.order_item[i].amount, 'frontspace') +"\n"
      }
          let printData=this.print.centeralign(32, this.resturant.restaurant_name).substring(0, 32)+"\n" +this.print.centeralign(32, this.resturant.business_address).substring(0, 32)+"\n"+this.print.centeralign(32, this.resturant.city).substring(0, 32)+this.print.nextline(this.resturant.city)+this.print.centeralign(32, this.resturant.state).substring(0, 32)+this.print.nextline(this.resturant.state)+this.print.centeralign(32, this.resturant.contact_number).substring(0, 32)+"\n"+"\n" +this.print.fillspace(16,"Customer No:" + item.phone, 'backspace') + this.print.nextline(item.phone) + this.print.fillspace(16,"Driver No:" +  this.print.empty(item.driver_phone), 'backspace') + "\n" +this.print.fillspace(16,"Invoice:" + item.name, 'backspace') + "\n" + this.print.fillspace(0,"Date:"+item.order_date +' '+item.order_time,'frontspace')+ "\n" + "--------------------------------\n" + this.print.fillspace(16, "Items", 'backspace') + "  Qty " + "Rate " + "Total\n"+ "--------------------------------\n" +ProductList +"--------------------------------\n" +this.print.fillspace(22, "Sub Total", 'backspace')+this.print.fillspace(10,Math.round(item.order_subtotal*100)/100 ,  'frontspace')+"\n"+this.print.fillspace(22, "GST", 'backspace')+this.print.fillspace(10,Math.round(item.total_tax_amount*100)/100,'frontspace')+"\n"+this.print.fillspace(22, "Discount", 'backspace')+this.print.fillspace(10, String(item.discount),  'frontspace') +"\n"+this.print.fillspace(22, "Delivery Charges", 'backspace')+this.print.fillspace(10, String(item.shipping_charges),  'frontspace')+"\n"+"--------------------------------\n" +this.print.fillspace(22, "Total", 'backspace')+this.print.fillspace(10,Math.round(item.total_amount*100)/100 ,  'frontspace')+"\n"+ "--------------------------------\n\n"+"\n\n"
          // let printData=this.print.centeralign(32, "Admin App").substring(0, 32)+"\n" +this.print.centeralign(32, "NO:100, Lake View Estate,").substring(0, 32)+"\n"+this.print.centeralign(32, "Kundrathur Road,Porur,").substring(0, 32)+"\n"+this.print.centeralign(32, "Chennai, TN").substring(0, 32)+"\n"+this.print.centeralign(32, "Phone: 9876543210").substring(0, 32)+"\n"+"\n"+this.print.fillspace(16,"Invoice:" + item.name, 'backspace') + this.print.fillspace(16,"Date:"+item.order_date,'frontspace')+ "\n" + "--------------------------------\n" + this.print.fillspace(16, "Items", 'backspace') + "  Qty " + "Rate " + "Total\n"+ "--------------------------------\n" +ProductList +"--------------------------------\n" +this.print.fillspace(22, "Sub Total", 'backspace')+this.print.fillspace(10,Math.round(item.order_subtotal*100)/100 ,  'frontspace')+"\n"+this.print.fillspace(22, "GST", 'backspace')+this.print.fillspace(10,Math.round(item.total_tax_amount*100)/100,'frontspace')+"\n"+this.print.fillspace(22, "Discount", 'backspace')+this.print.fillspace(10, String(item.discount),  'frontspace') +"\n"+this.print.fillspace(22, "Delivery Charges", 'backspace')+this.print.fillspace(10, String(item.shipping_charges),  'frontspace')+"\n"+"--------------------------------\n" +this.print.fillspace(22, "Total", 'backspace')+this.print.fillspace(10,Math.round(item.total_amount*100)/100 ,  'frontspace')+"\n"+ "--------------------------------\n\n"+"\n\n"
    // let printData="admin"
    console.log(printData)
    // let printData="adjhsajkd"
    // let xyz=this.connectBT(address).subscribe(data=>{
      this.btSerial.write(printData).then(dataz=>{

        let mno=this.alertCtrl.create({
          title:"Print SUCCESS!",
          buttons:['Dismiss']
        });
        mno.present();

        // xyz.unsubscribe();
      },errx=>{
        let mno=this.alertCtrl.create({
          title:"ERROR "+errx,
          buttons:['Dismiss']
        });
        mno.present();
      });
      // },err=>{
      //   let mno=this.alertCtrl.create({
      //     title:"ERROR "+err,
      //     buttons:['Dismiss']
      //   });
      //   mno.present();
      // });
  }
  get_restaurant() {
    this.DBservice.get_restaturantdetail(localStorage.restaurant)
      .then(data => {
        console.log(data);
        this.resturant = data.message[0];
        // this.resturant = data.data;
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderdetailsPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  Cancelstatus(item) {
    console.log(item)
    let alert = this.alertCtrl.create({
      title: 'Alert',
      message: 'Do You Wish to Cancel this order?',
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            var data={
              status: 'Restaurant Declined',
               name:item.name
              }
              let loader = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Loading Please Wait...'
    });
     loader.present();
      setTimeout(() => { 
        loader.dismiss();
      }, 3000); 
            this.DBservice.update_order(data)
              .then(data => {
                setTimeout(() => { 
                loader.dismiss();
              }, 50);

                this.navCtrl.pop()
                this.DBservice.alert('Order has been Declined')
                // console.log(data.message.result);
                // if (data.message.result == "Success") {
                //   this.item.status = 'Cancelled'
                //   location.href = "#/home/orders/orders"
                // }
              }, error => {
                console.log(JSON.stringify(error.json()));
              });
          }
        },
        {
          text: 'No',
          handler: () => {
            
          }
        }
      ]
    });
    alert.present();

  }

  orderpicked(item,status,preparation_time,preparation_time_hr){
    let loader = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Loading Please Wait...'
    });
     loader.present();
      setTimeout(() => { 
        loader.dismiss();
      }, 3000);
    var data={
       status:status,
       name:item.name,
       preparation_time:preparation_time,
       preparation_time_hr:preparation_time_hr
      }

    this.DBservice.update_order(data)
      .then(data => {
       if(status == 'Restaurant Accepted')
       {
         this.navCtrl.pop()
         this.DBservice.alert(status)
         this.testprint();
       }
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  } 

  changestatus(item) {
    console.log(item)
    var preparation_time;
    var check_value = 0;
    for(var i=0;i < this.delivery_slot.length;i++){
      var k=i;
      if(this.delivery_slot[k].is_default  == 1){
         preparation_time = this.delivery_slot[k].estimated_time;
         check_value =1;
      }
    }
    if(localStorage.check_default == "false"){
    let modal = this.modalCtrl.create(MarkaspaidPage,{type:'date'});
    modal.present();
    modal.onWillDismiss((value: any) => {
      if (value) {
        console.log(value)
            this.orderpicked(item,'Restaurant Accepted',value.preparation_time,'')
        }
    });
  }
  else
    this.orderpicked(item,'Restaurant Accepted',preparation_time,'')
    // var data ={}
    // if(item.status == 'Placed'){
    // data={
    //   status:'Restaurant Accepted',
    //    name:item.name
    //   }
    // }
    //   let loader = this.loadingCtrl.create({
    //   spinner: 'bubbles',
    //   content: 'Loading Please Wait...'
    // });
    //  loader.present();
    //   setTimeout(() => { 
    //     loader.dismiss();
    //   }, 3000); 

    // this.DBservice.update_order(data)
    //   .then(data => {
    //     setTimeout(() => { 
    //     loader.dismiss();
    //   }, 50);

    //     this.navCtrl.pop()

    //       if(item.status == 'Placed')
    //         this.DBservice.alert('Order Accepted')
    //   }, error => {
    //     console.log(JSON.stringify(error.json()));
    //   });
  }

  

    


}



// WEBPACK FOOTER //
// ./src/pages/orderdetails/orderdetails.ts